


















import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';

import { useDeclination } from '~/diptyqueTheme/composable';
import type { StoryTellingModel } from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'StoryTellingContent__desktopDeclination2',
  components: {
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    VaimoHeading: () => import('atoms/VaimoHeading.vue')
  },
  props: {
    declinationData: {
      required: true,
      type: Object as PropType<StoryTellingModel>
    }
  },
  setup(props) {
    const { getBannerData: bannerData } = useDeclination(props.declinationData);

    return {
      bannerData
    };
  }
});
